import type { ShowToastOptions } from '@common/components/Notifications';

type ExpiryNotice = { title: string; message: string };

export const buildExpiryToast = ({ title, message }: ExpiryNotice): [string, ShowToastOptions] => [
  title,
  { tone: 'warning', detail: message, id: `basket-expiry|${message}` },
];
